// import axios from 'axios';
// import { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Container from 'react-bootstrap/Container';
// import Navbar from 'react-bootstrap/Navbar';

// function TextLinkExample() {
//   return (
//     <div>
//       <Navbar className="bg-body-tertiary">
//         <Container>
//           <div style={{ width: '100px', height: '100px', borderRadius: '50px', overflow: 'hidden' }}>
//             {logo && <img style={{ width: '100%', height: '100%', backgroundSize: 'contain' }} src={logo} alt="Company Logo" />}
//           </div>
//           <Navbar.Toggle />
//           <Navbar.Collapse className="justify-content-end">
//             <Navbar.Text>
//               <Button variant="light" style={{ backgroundColor: 'white', border: 'none' }} onClick={handleShow}>
//                 <span style={{ textDecoration: 'none', fontFamily: 'Roboto' }}> Logout <i className='fa fa-sign-out'></i></span>
//               </Button>

//               <Modal show={show} onHide={handleClose} animation={false}>
//                 <Modal.Header closeButton></Modal.Header>
//                 <Modal.Body>Are you sure you want to logout?</Modal.Body>
//                 <Modal.Footer>
//                   <Button variant="secondary" onClick={handleClose}>
//                     No
//                   </Button>
//                   <Button variant="primary" onClick={handleLogout}>
//                     Yes
//                   </Button>
//                 </Modal.Footer>
//               </Modal>
//             </Navbar.Text>
//           </Navbar.Collapse>
//         </Container>
//       </Navbar>
//     </div>
//   );
// }

// export default TextLinkExample;

const products = [
  {
    id: 1,
    image: "./images/image 454.png", // Replace with actual image path
    title: "Vibrant Aura Gold Bangles",
    grossWeight: "25gm",
    netWeight: "17gm",
    stoneWeight: "8gm",
    size: "2.0",
  },
  {
    id: 2,
    image: "./images/image 454.png",
    title: "Vibrant Aura Gold Bangles",
    grossWeight: "25gm",
    netWeight: "17gm",
    stoneWeight: "8gm",
    size: "2.0",
  },
  {
    id: 3,
    image: "./images/image 454.png",
    title: "Vibrant Aura Gold Bangles",
    grossWeight: "25gm",
    netWeight: "17gm",
    stoneWeight: "8gm",
    size: "2.0",
  },
  {
    id: 4,
    image: "./images/image 454.png",
    title: "Vibrant Aura Gold Bangles",
    grossWeight: "25gm",
    netWeight: "17gm",
    stoneWeight: "8gm",
    size: "2.0",
  },
];

export default function ProductGrid() {
  return (
    <div className="container mx-auto p-4">
      <div
        className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"
        style={{ display: "flex", borderRadius: "10px" }}
      >
        {products.map((product) => (
          <div
            key={product.id}
            className="border rounded-lg shadow-lg p-4 text-center"
          >
            <img
              src={product.image}
              alt={product.title}
              width={200}
              height={200}
              className="mx-auto"
            />
            <h2 className="text-lg font-semibold mt-2">{product.title}</h2>
            <p className="text-sm text-gray-600">
              Gross Weight: {product.grossWeight}
            </p>
            <p className="text-sm text-gray-600">
              Net Weight: {product.netWeight}
            </p>
            <p className="text-sm text-gray-600">
              Stone Weight: {product.stoneWeight}
            </p>
            <p className="text-sm text-gray-600">Size: {product.size}</p>
            <button className="bg-yellow-600 text-white px-4 py-2 rounded-lg mt-2 w-full">
              ADD TO CART
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
